import { useState, useEffect } from "react";
import { usePopper } from "react-popper";
import axios from "axios";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faImages } from "@fortawesome/pro-regular-svg-icons";
import { Popover } from "@headlessui/react";

export default function BookingGallery({ ...props }) {
    let [referenceElement, setReferenceElement] = useState();
    let [popperElement, setPopperElement] = useState();
    let [galleries, setGalleries] = useState([]);
    let [loading, setLoading] = useState(true);
    let { styles, attributes } = usePopper(referenceElement, popperElement, {
        placement: "top",
    });

    useEffect(() => {
        fetchGalleries();
    }, []);

    const fetchGalleries = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}galleries`);
            setGalleries(response.data.data || []);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching galleries:", error);
            setLoading(false);
        }
    };

    const insertGalleryShortcode = (galleryId) => {
        const currentMessage = props.values?.message || "";
        const shortcode = `[gallery id='${galleryId}']`;

        // Append shortcode to message
        const newMessage = currentMessage ? `${currentMessage}\n${shortcode}` : shortcode;
        props.setFieldValue("message", newMessage);
    };

    return (
        <Popover>
            <Popover.Button
                ref={setReferenceElement}
                className="ml-4 relative inline-block text-white bg-primary px-2 py-1 rounded-xl hover:bg-primary_hover transition duration-150 ease-in-ease-out hover:-translate-y-0.5"
            >
                <FontAwesomeIcon className="h-4 w-4" aria-hidden="true" icon={faImages} />
            </Popover.Button>

            <Popover.Panel ref={setPopperElement} style={styles.popper} {...attributes.popper} className="bg-white rounded-lg pb-4 z-20 max-w-xs">
                <h1 className="bg-dark_background text-white p-2 rounded-t-lg">Send Gallery</h1>
                <div className="flex flex-col items-start px-4 mt-2 max-h-64 overflow-y-auto">
                    {loading ? (
                        <div className="text-sm text-gray-500 py-2">Loading galleries...</div>
                    ) : galleries.length === 0 ? (
                        <div className="text-sm text-gray-500 py-2">No galleries available</div>
                    ) : (
                        galleries.map((gallery) => (
                            <button key={`gallery_${gallery.id}`} type="button" className="text-gray-600 hover:text-primary text-left py-1 text-sm" onClick={() => insertGalleryShortcode(gallery.id)}>
                                <div className="font-medium">{gallery.display_name}</div>
                                <div className="text-xs text-gray-400">
                                    {gallery.photo_count} photo{gallery.photo_count !== 1 ? "s" : ""}
                                </div>
                            </button>
                        ))
                    )}
                </div>
            </Popover.Panel>
        </Popover>
    );
}
